<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Weekly Banking</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <mdb-date-picker :autoHide="true" v-model="date" label="Date Monday Only" />
                </mdb-col>
                <mdb-col md="3" class="align-self-center">
                    <mdb-btn v-if="!loading" @click="getData()" color="primary" size="sm">Search</mdb-btn>
                    <mdb-spinner small v-if="loading" color="blue" />
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <mdb-col md="3">
                  Total Collection: RM <strong>{{total_collection}}</strong>
                </mdb-col>
                <mdb-col md="3">
                  <div>Total Percentage Deduction: RM <strong>{{total_percentage_deduction}}</strong></div>
                  <div>Total Amount Deduction: RM <strong>{{total_amount_deduction}}</strong></div>
                </mdb-col>
            </mdb-row>
             <mdb-tbl responsive striped>
                <mdb-tbl-head>
                  <tr>
                      <th width="5%">#</th>
                      <th width="30%">Merchant.</th>
                      <th width="30%">Banking</th>
                      <th class="text-right">Dispute</th>
                      <th class="text-right">Deduction</th>
                      <th class="text-right">Payment Amount</th>
                      <th class="text-right">Date Time</th>
                  </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                  <tr v-for="(bank, index) in data" :key="bank.id">
                    <td>{{index+1}}</td>
                    <td @click="showPDF(bank)" class="pdf-download">{{bank.merchant.name}}</td>
                    <td>
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Bank Name</span>
                          <a slot="reference">
                              {{bank.bnm_code}}
                          </a>
                        </mdb-tooltip>
                      </div>
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Beneficial Name</span>
                          <a slot="reference">
                              {{bank.beneficial_name}}
                          </a>
                        </mdb-tooltip>
                      </div>
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Account Number</span>
                          <a slot="reference">
                              {{bank.account_number}}
                          </a>
                        </mdb-tooltip>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Dispute Compensate</span>
                          <a slot="reference">
                              {{bank.dispute_compensate}}
                          </a>
                        </mdb-tooltip>
                      </div>
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Dispute Penalty</span>
                          <a slot="reference">
                              {{bank.dispute_penalty}}
                          </a>
                        </mdb-tooltip>
                      </div>
                    </td>
                    <td class="text-right">
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Amount Deduction</span>
                          <a slot="reference" class="text-danger">
                              {{bank.contract_deduction_amount}}
                          </a>
                        </mdb-tooltip>
                      </div>
                      <div>
                        <mdb-tooltip trigger="hover" :options="{placement: 'top'}">
                          <span slot="tip">Percentage Deduction</span>
                          <a slot="reference" class="text-success">
                              {{bank.contract_deduction_percentage}}
                          </a>
                        </mdb-tooltip>
                      </div>
                    </td>
                    <td class="text-right">{{bank.payment_amount}}</td>
                    <td class="text-right">
                      <div>{{momentFormat16(bank.created_at)}}</div>
                      <div>{{bank.payment_description}}</div>
                    </td>
                  </tr>
                </mdb-tbl-body>
             </mdb-tbl>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer, mdbDatePicker, mdbRow, mdbCol, mdbBtn, mdbTbl, mdbTblHead, mdbTblBody, mdbTooltip, mdbSpinner } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {momentFormat16} from '../js/helper';
import { APP_STORAGE_URL } from '../js/config';

export default {
  name: 'Weekly_Banking',
  components: {
    mdbContainer, mdbBtn, mdbTbl, mdbTblHead, mdbTblBody, mdbSpinner,
    AppNavigation, mdbDatePicker, mdbRow, mdbCol, mdbTooltip
  },
  data: ()=>({
    date: "",
    loading:false,
    data: [],
    total_collection: 0,
    total_percentage_deduction: 0,
    total_amount_deduction: 0
  }),
  methods: {
    getData(){
      if(!this.date){
        return false;
      }
      if(this.loading){
        return false;
      }
      this.loading=true;
      ajax({
        url: "admin/get_weekly_banking",
        data: {
          date: this.date
        },
        complete: ()=>this.loading=false,
        success: result=>{
          this.data=result.data.records;
          this.total_amount_deduction=result.data.total_amount_deduction;
          this.total_percentage_deduction=result.data.total_percentage_deduction;
          this.total_collection=result.data.total_collection;
        },
        fail: fail=>this.$notify.error({message: fail.message, position: 'top right', timeOut: 5000})
      })
    },
    momentFormat16(date){
      return momentFormat16(date);
    },
    showPDF(pdf){
      let url=APP_STORAGE_URL+pdf.file;
      window.open(url);
    }
  },
  mounted: function(){
    var date = new Date();
    var day = date.getDay();
    var prevMonday = new Date();
    if(date.getDay() == 0){
      prevMonday.setDate(date.getDate() - 7);
    }
    else{
      prevMonday.setDate(date.getDate() - (day-1));
    }
    this.date=prevMonday.getFullYear()+'-'+("0" + (prevMonday.getMonth()+1)).slice(-2)+'-'+("0"+prevMonday.getDate()).slice(-2);
  }
}
</script>

<style scoped>
.pdf-download:hover{
  color: #4285F4;
  font-weight: bold;
  cursor: pointer;
}
</style>